import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'

// api.js only stubs `grecaptcha`, then loads the real library from gstatic. If
// a blocker stops that, execute() queues forever and the button does nothing.
const LOAD_TIMEOUT = 10000

const ready = () => typeof window.grecaptcha?.render == 'function'

const InvisibleRecaptcha = (props, ref) => {
  const [ error, setError ] = useState(null)
  const recaptcha = useRef()
  const timedOut = useRef(false)
  const pending = useRef(false)

  const unavailable = reason => {
    pending.current = false
    setError('We couldn’t load our spam check. Please disable any content blockers or try another browser.')
    window.Honeybadger?.notify(`reCAPTCHA ${reason}`, {
      context: { rescued: true, path: location.pathname },
    })
  }

  useEffect(() => {
    const timeout = setTimeout(() => {
      timedOut.current = true
      if (pending.current && !ready()) unavailable('did not load')
    }, LOAD_TIMEOUT)
    return () => clearTimeout(timeout)
  }, [])

  useImperativeHandle(ref, () => ({
    execute () {
      setError(null)
      if (!ready() && timedOut.current) return unavailable('did not load')
      pending.current = !ready()
      recaptcha.current.execute()
    },
    reset: () => recaptcha.current?.reset(),
  }))

  return (
    <>
      <ReCAPTCHA
        {...props}
        ref={recaptcha}
        size="invisible"
        onErrored={() => unavailable('errored')}
      />
      {error && <div className="alert alert-danger mt-3" role="alert">{error}</div>}
    </>
  )
}

export default forwardRef(InvisibleRecaptcha)
